import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { NotFoundState } from "@/components/ui/empty-state";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      <NotFoundState
        resourceName="página"
        onGoBack={() => navigate("/")}
      />
    </div>
  );
};

export default NotFound;
